export const toSnakeCase = city => {
  if (!city) return;

  return city
    .split(".")
    .join("")
    .split(" ")
    .map(c => c.toLocaleLowerCase())
    .join("_");
};

export const capitalize = (phrase, locale = "en-US") => {
  if (!phrase || phrase.length === 0) return phrase;

  return phrase
    .split(" ")
    .map(word => word.charAt(0).toUpperCase(locale) + word.substring(1))
    .join(" ");
};
